import { KeyboardEventHandler } from 'react';

// TODO: rename helper as form helper and append any form helpers
export const preventSubmitOnEnterPressed: KeyboardEventHandler = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};
